<div class="socio-view">
    <div class="card">
        <div class="card-header">
            <h6 class="card-title">
                Quadro de Sócios e Administradores - QSA
            </h6>
            <p class="form-text text-muted">
                Sócios e adminitradores da empresa
            </p>
        </div>

        <sgt-socio-table
            [socios]="socios"
            [emptyText]="emptyText">
        </sgt-socio-table>
    </div>
</div>